//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"BallsKeepOption",1,0],[0,"BlendsOption",1,0],[1,"Lattice1",0,"ScCollector",0],[1,"Lattice2",0,"ScCollector",0],[1,"MaxCheckingDistance",0,"Expression",0],[1,"RodDiameter",0,"Expression",0],[0,"RodSizeOption",1,0],[1,"RodsPerVertexExpression",0,"Expression",0],[0,"TessellationFactor",1,0],[0,"TessellationOption",1,0]],[],[]];
SPLM.Features.ConnectLattices3Builder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ConnectLattices3Builder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ConnectLattices3Builder.RodsizeOptions = Object.freeze({
    "Variable" : "Variable", "Fixed" : "Fixed"});

SPLM.Features.ConnectLattices3Builder.BallsKeepOptions = Object.freeze({
    "KeepExisting" : "KeepExisting", "Remove" : "Remove"});

SPLM.Features.ConnectLattices3Builder.BlendsOptions = Object.freeze({
    "KeepExisting" : "KeepExisting", "UseMinimumBlends" : "UseMinimumBlends", "UseAverageBlends" : "UseAverageBlends", "UseMaximumBlends" : "UseMaximumBlends", "Remove" : "Remove"});

SPLM.Features.ConnectLattices3Builder.TessellationOptions = Object.freeze({
    "UseFinest" : "UseFinest", "UseAverage" : "UseAverage", "UseCoarsest" : "UseCoarsest", "SpecifyNew" : "SpecifyNew"});

export default SPLM;